// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.floorplans.RentalManagerUserPropertyFloorPlanCreateWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { ListingAlias, UserPropertyFloorPlanCreateResponseWebDto } from '../..';

interface CreateParams {
  listingAlias: ListingAlias;
}

export const RentalManagerUserPropertyFloorPlanCreateWebApiHandler_create_Path =
  '/api/web/v1/users/properties/floorPlans/create';

/**
 * Create a floor plan for the property
 * @deprecated
 */
export const RentalManagerUserPropertyFloorPlanCreateWebApiHandler_create = (
  getParams: CreateParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<CreateParams, never, UserPropertyFloorPlanCreateResponseWebDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyFloorPlanCreateWebApiHandler_create_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};
